enum PolarProductTypes {
  NameSticker = "namesticker",
  Classic = "classic",
  ClassicNew = "classicNew",
  Mini = "mini",
  BoldFrame = "boldFrame",
  NarrowFrame = "narrowFrame",
  MiniHalf = "miniHalf",
  GraphicNamesticker = "graphicNamesticker",
  Minime = "minime",
  PhotoNamesticker = "photoNamesticker",
  VerticalFrame = "verticalFrame",
  StoryPhoto = "storyPhoto",
  MyRoutineCalendar = "myRoutineCalendar",
  CollaboCalendar = "collaboCalendar",
  ColornamesOriginal = "colornamesOriginal",
  ColornamesColorful = "colornamesColorful",
  ColornamesPhoto = "colornamesPhoto",
  SelfCutSticker = "selfCutSticker",
  PhotoCollageSticker = "photoCollageSticker",
  PrintingTicket = "printingTicket",
  FullFrame = "fullFrame",
  FullFrame6x8 = "fullFrame6x8",
  MultiFrame6x8 = "multiFrame6x8",
  PaperToy = "paperToy",
  GraphicNamesticker12cut = "graphicNamesticker12cut",
  CardCoverSticker = "cardCoverSticker",
  IdolAteez = "idolAteez",
  CardCoverStickerDieCut = "cardCoverStickerDieCut",
  IpSpecial = "ipSpecial",
  PhotoCard = "photoCard",
  IpSecialColornames = "ipSpecialColornames",
  PhotoCardEvolis = "photoCardEvolis",
  PhotoCardEvolisIp = "photoCardEvolisIp",
  PhotoCardEvolisLucky = "photoCardEvolisLucky",
  PhotoCardEvolisId = "photoCardEvolisId",
  PhotoCardEvolisHighTeen = "photoCardEvolisHighTeen",
  PhotoCardEvolisIgloo = "photoCardEvolisIgloo",
  IglooPhotoBooth = "iglooPhotoBooth",
  IpSpecialStickerMaker = "ipSpecialStickerMaker",
  Card = "card",
  Seal = "seal",
  Phone = "phone",
  Griptok = "griptok",
  Keyring = "keyring",
  AcrylicStand = "acrylicStand",
  Plate = "plate",
  AirFreshener = "airFreshener",
  WaterGlitter = "waterGlitter",
  BallPen = "ballpen",
  KeyringAcryl2cut = "keyringAcryl2cut",
  KeyringAcryl4cut = "keyringAcryl4cut",
  FreeFormCutPath = "freeFormCutPath",
  TimeTable = "timeTable",
  TemplateFrame = "templateFrame",
  SloganSticker2Cut = "sloganSticker2Cut",
  SloganSticker3Cut = "sloganSticker3Cut",
  DaisoGiftCard5K = "daisoGiftCard5k",
  DaisoGiftCard10K = "daisoGiftCard10k",
  DaisoGiftCard30K = "daisoGiftCard30k",
  DaisoGiftCard50K = "daisoGiftCard50k",
  CheerUpGroupSlogan = "cheerUpGroupSlogan",
  CheerUpMemberSlogan = "cheerUpMemberSlogan",
  IpSpecialCheerUp = "ipSpecialCheerUp",
  CheerUpCustomSlogan = "cheerUpCustomSlogan",
}

enum PolarProductCategory {
  NameStickerKind = "namestickerkind",
  PhotoStickerKind = "photostickerkind",
  EtcStickerKind = "etcstickerkind",  
  IpSpecialKind = "ipspecialkind",
}

export { PolarProductTypes, PolarProductCategory };
